import { SelectOptionElement } from '@odin-labs/components';
import { CreateDeveloperJobsiteAccessGrantInput } from 'apollo/generated/client-operations';
import { FormInputTypes, GridColSpan, TypedFormInputs } from 'components/form';

export type AddDataSharingGrantFormData = {
  developerId: SelectOptionElement;
  agreementReference: string;
};

export const getFormInputs = ({
  developersOptions,
}: {
  developersOptions: SelectOptionElement[];
}): TypedFormInputs<AddDataSharingGrantFormData> => ({
  developerId: {
    element: FormInputTypes.Select,
    label: 'Client',
    elementProps: {
      placeholder: 'Select client',
      options: developersOptions,
    },
    validation: { required: true },
    layout: GridColSpan.SpanFull,
  },
  agreementReference: {
    element: FormInputTypes.Field,
    label: 'Agreement reference',
    elementProps: {
      placeholder: 'e.g. email thread or contract reference',
    },
    validation: { required: true },
    layout: GridColSpan.SpanFull,
  },
});

export const getDefaultValues = (): AddDataSharingGrantFormData => ({
  developerId: null,
  agreementReference: '',
});

export const getCreateInput = (
  jobsiteId: string,
  data: AddDataSharingGrantFormData,
): CreateDeveloperJobsiteAccessGrantInput => ({
  jobsiteId,
  granteeDeveloperId: data.developerId.value,
  agreementReference: data.agreementReference.trim(),
});
